import React from 'react';
import './Spinner.css';
import IvisNk9Logo from '../../assets/IvisNk9Logo.png';
import { useSpinner } from '../../context/SpinnerContext';

const Spinner = () => {
    const { isVisible, message } = useSpinner();

    if (!isVisible) return null;

    return (
        <div className="spinner-overlay">
            <div className="spinner-container">
                {/* Contenedor unificado del logo y anillo */}
                <div className="spinner-logo-ring-container">
                    {/* Logo central estático */}
                    <div className="spinner-logo">
                        <img src={IvisNk9Logo} alt="IVIS NK9" />
                    </div>
                    
                    {/* Anillo giratorio */}
                    <div className="spinner-ring"></div>
                </div>
                
                {/* Texto de carga */}
                <div className="spinner-text">
                    {message}
                </div>
            </div>
        </div>
    );
};

export default Spinner;